import React from "react";
import {ComposableMap, Geographies, Geography} from "react-simple-maps";

const geoUrl = "https://gist.githubusercontent.com/paladinescamila/92c4173875672620979b86010cfb1074/raw/10982984e8be17a73d562f38f8ad6a5f0b14b3de/features.json";

function MapChart({topCodes}) {
	return (
		<ComposableMap
			projectionConfig={{
				scale: 200,
			}}>
			<Geographies geography={geoUrl}>
				{({geographies}) =>
					geographies.map((geo) => {
						const color = topCodes.indexOf(geo.id) >= 0 ? "var(--blue-50)" : "#FFF";
						return <Geography key={geo.rsmKey} geography={geo} fill={color} />;
					})
				}
			</Geographies>
		</ComposableMap>
	);
}

export default MapChart;
